module.exports = __webpack_public_path__ + "static/media/thumbsup_icon.80659bb8.png";